import { fetchStocks } from "./inventoryAction";
import { formatData } from "./utils";

export function fetchPurchases(){
    console.log("FIRED ACTION FETCH PURCHASES" )
    return async function(dispatch){
        dispatch({
            type: "FETCH_PURCHASES_START",
            payload: ""
            
        })
        try {
            const response = await fetch('/stocks/getList',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page:"achat",
                }),
                credentials: 'same-origin',
            }); 
            
            const list = await response.json()
            console.log(list)// list returns new object created

            if(!list.error){ // no errors, return new Object
                
                dispatch( getPurchases(formatData(list.reverse())) )
                dispatch({ type: "FETCH_PURCHASES_FULFILLED", payload:"" })
                console.log("purchases fetched")
                
                // dispatch(fetchStocks())
            
            } else {
                dispatch({
                    type: "FETCH_PURCHASES_ERROR",
                    payload: list.error.message
                })
            }
            
        } catch (err) {
            dispatch({
                type: "FETCH_PURCHASES_ERROR",
                payload: err
                
            })
        }
    }
}
export function groupProductsByProductId(products) {
    if (!products || !Array.isArray(products)) {
        return {};
    }
    return products.reduce((acc, product) => {
        const { product_id, ...rest } = product;
    
        if (!acc[product_id]) {
            acc[product_id] = product
            acc[product_id].list = [];
            // acc[product_id].totalQuantity = rest.quantity || 0
            // acc[product_id].totalCost = rest.cost || 0
            // acc[product_id].price_ttc = rest.price_ttc || 0
            // acc[product_id].price_ht = rest.price_ht || 0
        } else {
            acc[product_id].quantity += rest.quantity || 0;
            acc[product_id].cost += rest.cost || 0;
            acc[product_id].price_ttc += rest.price_ttc || 0;
            acc[product_id].price_ht += rest.price_ht || 0;
            acc[product_id].list.push(product);

            // // Calcul de la moyenne pondérée du price_ht
            // acc[product_id].price_ht =
            //     (acc[product_id].price_ht * (acc[product_id].quantity - rest.quantity) + 
            //     rest.price_ht * rest.quantity) / acc[product_id].quantity;
        }
    
        return acc;
    }, {});
  }

export function fetchPurchaseDetails(id){
    console.log("FIRED ACTION FETCH PURCHASE" )
    return async function(dispatch){
        dispatch({
            type: "FETCH_PURCHASE_START",
            payload: ""
        })
        try {
            const response = await fetch('/stocks/single',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    page:"transfer",
                    id,
                }),
                credentials: 'same-origin',
            }); 
            
            const transfer = await response.json()
            console.log(transfer)// transfer returns new object created

            if(!transfer.error){ // no errors, return new Object         
                const groupedProducts = groupProductsByProductId(transfer.products);
                transfer.products = Object.values(groupedProducts);
                console.log('==============fetchPurchaseDetails======================');
                console.log({transfer});
                console.log('====================================');    
                return transfer
            } else {
                dispatch({
                    type: "FETCH_PURCHASE_ERROR",
                    payload: transfer.error.message
                })
                return {}
            }
            
        } catch (err) {
            dispatch({
                type: "FETCH_PURCHASE_ERROR",
                payload: err
            })
        }
    }
}

export function createPurchase(newPurchase){
    // console.log("FIRED ACTION CREATE PURCHASE", newPurchase)
    return async function(dispatch){
        dispatch({
            type: "CREATE_PURCHASE_START",
            payload: ""
            
        })
        try {
            const response = await fetch('/stocks/addData',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page:"purchases",
                    data:newPurchase
                }),
                credentials: 'same-origin',
            }); 
            
            const createdPurchase = await response.json()
            console.log(createdPurchase)// createdPurchase returns new object created

            if(createdPurchase.id){ // no errors, return new Object
                dispatch({
                    type: "NEW_PURCHASE",
                    payload: createdPurchase
                    
                })
                dispatch(fetchStocks())
                dispatch({ type: "CREATE_PURCHASE_FULFILLED", payload:"" })
                console.log("Purchase created")

                // if arrivage, change status
                // received = true
                if (newPurchase.arrivage_id){
                    dispatch({ type: "RECEIVED_ARRIVAGE", payload: newPurchase.arrivage_id })
                }
                return "OK"
            } else {
                dispatch({
                    type: "CREATE_PURCHASE_ERROR",
                    payload: createdPurchase.error.message
                    
                })
            }
            throw new Error(createdPurchase.error.message)
        } catch (err) {
            console.log("[ERROR] SUBMIT PURCHASE ", err);
            dispatch({
                type: "CREATE_PURCHASE_ERROR",
                payload: err
                
            })
            throw err;
        }
    }
}
export function updatePurchase(newPurchase){
    // console.log("FIRED ACTION CREATE PURCHASE", newPurchase)
    return async function(dispatch){
        dispatch({
            type: "CREATE_PURCHASE_START",
            payload: ""
        })
        try {
            const response = await fetch('/stocks/addData',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page: "purchases/update",
                    data: newPurchase
                }),
                credentials: 'same-origin',
            }); 
            
            const createdPurchase = await response.json()
            console.log(createdPurchase)// createdPurchase returns new object created

            if(createdPurchase.id){ // no errors, return new Object
                dispatch({
                    type: "DELETE_PURCHASE",
                    payload: newPurchase.id
                    
                })
                dispatch({
                    type: "NEW_PURCHASE",
                    payload: createdPurchase
                    
                })
                dispatch(fetchStocks())
                dispatch({ type: "CREATE_PURCHASE_FULFILLED", payload:"" })
                console.log("Purchase created")

                // if arrivage, change status
                // received = true
                if (newPurchase.arrivage_id){
                    dispatch({ type: "RECEIVED_ARRIVAGE", payload: newPurchase.arrivage_id })
                }
                return "OK"
            } else {
                dispatch({
                    type: "CREATE_PURCHASE_ERROR",
                    payload: createdPurchase.error.message
                    
                })
            }
            throw new Error(createdPurchase.error.message)
        } catch (err) {
            console.log("[ERROR] SUBMIT PURCHASE ", err);
            dispatch({
                type: "CREATE_PURCHASE_ERROR",
                payload: err
                
            })
            throw err
        }
    }
}
export function addFilesPurchase(files){
    return async function(dispatch){
        dispatch({
            type: "ADD_FILES_PURCHASE_START",
            payload: ""
            
        })
        try {
            const response = await fetch('/stocks/addData',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page:"purchases/add/files",
                    data:files
                }),
                credentials: 'same-origin',
            }); 
            
            const updatedPurchase = await response.json()
            console.log(updatedPurchase)// updatedPurchase returns new object created

            if(updatedPurchase.id){ // no errors, return new Object
                dispatch({
                    type: "UPDATE_PURCHASE",
                    payload: updatedPurchase
                    
                })
                dispatch({ type: "ADD_FILES_PURCHASE_FULFILLED", payload:"" })
                console.log("Purchase updated")

            } else {
                dispatch({
                    type: "ADD_FILES_PURCHASE_ERROR",
                    payload: updatedPurchase.error.message
                    
                })
                
            }
            
        } catch (err) {
            console.log("[ERROR] files PURCHASE ", err);
            dispatch({
                type: "ADD_FILES_PURCHASE_ERROR",
                payload: err
                
            })
        }
    }
}
export function deleteFilePurchase({ id, password, filename }){
    return async function(dispatch){
        dispatch({
            type: "ADD_FILES_PURCHASE_START",
            payload: ""

        })
        try {
            const response = await fetch('/stocks/addData',{
                method:'POST',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page:"purchases/delete/file",
                    data:{ id, password, filename }
                }),
                credentials: 'same-origin',
            });

            const res = await response.json()
            console.log(res)// res returns {success, message} or updated purchase

            if(res.success === false){ // wrong password / not found, business error surfaced by backend
                dispatch({
                    type: "ADD_FILES_PURCHASE_ERROR",
                    payload: res.message || "Erreur lors de la suppression"
                })
            } else if(res.id){ // no errors, updated purchase returned
                dispatch({
                    type: "UPDATE_PURCHASE",
                    payload: res

                })
                dispatch({ type: "ADD_FILES_PURCHASE_FULFILLED", payload:"" })
                console.log("Purchase file deleted")

            } else {
                dispatch({
                    type: "ADD_FILES_PURCHASE_ERROR",
                    payload: (res.error && res.error.message) || "Erreur lors de la suppression"

                })
            }

        } catch (err) {
            console.log("[ERROR] delete file PURCHASE ", err);
            dispatch({
                type: "ADD_FILES_PURCHASE_ERROR",
                payload: err

            })
        }
    }
}
export function addFacturesPurchase(factures){
    return async function(dispatch){
        dispatch({
            type: "ADD_FILES_PURCHASE_START",
            payload: ""
            
        })
        try {
            const response = await fetch('/stocks/addData',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page:"purchases/add/factures",
                    data:factures
                }),
                credentials: 'same-origin',
            }); 
            
            const updatedPurchase = await response.json()
            console.log(updatedPurchase)// updatedPurchase returns new object created

            if(updatedPurchase.id){ // no errors, return new Object
                dispatch({
                    type: "UPDATE_PURCHASE",
                    payload: updatedPurchase
                    
                })
                dispatch({ type: "ADD_FILES_PURCHASE_FULFILLED", payload:"" })
                console.log("Purchase updated")

            } else {
                dispatch({
                    type: "ADD_FILES_PURCHASE_ERROR",
                    payload: updatedPurchase.error.message
                    
                })
                
            }
            
        } catch (err) {
            console.log("[ERROR] factures PURCHASE ", err);
            dispatch({
                type: "ADD_FILES_PURCHASE_ERROR",
                payload: err
                
            })
        }
    }
}
export function createArrivage(newPurchase){
    return async function(dispatch){
        dispatch({
            type: "CREATE_ARRIVAGE_START",
            payload: ""
            
        })
        try {
            const response = await fetch('/stocks/addData',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page:"purchases/arrivages",
                    data:newPurchase
                }),
                credentials: 'same-origin',
            }); 
            
            const createdPurchase = await response.json()
            console.log(createdPurchase)// createdPurchase returns new object created

            if(createdPurchase.id){ // no errors, return new Object
                dispatch({
                    type: "NEW_ARRIVAGE",
                    payload: createdPurchase
                    
                })
                dispatch(fetchStocks())
                dispatch({ type: "CREATE_ARRIVAGE_FULFILLED", payload:"" })
                console.log("Purchase created")
            } else {
                dispatch({
                    type: "CREATE_ARRIVAGE_ERROR",
                    payload: createdPurchase.error.message
                    
                })
                
            }
            
        } catch (err) {
            console.log("[ERROR] SUBMIT ARRIVAGE ", err);
            dispatch({
                type: "CREATE_ARRIVAGE_ERROR",
                payload: err
                
            })
        }
    }
}
export function updateArrivage(newPurchase){
    return async function(dispatch){
        dispatch({
            type: "CREATE_ARRIVAGE_START",
            payload: ""
            
        })
        try {
            const response = await fetch('/stocks/addData',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page:"purchases/arrivages/update",
                    data: newPurchase
                }),
                credentials: 'same-origin',
            }); 
            
            const createdPurchase = await response.json()
            console.log(createdPurchase)// createdPurchase returns new object created

            if(createdPurchase.id){ // no errors, return new Object
                dispatch({
                    type: "DELETE_ARRIVAGE",
                    payload: newPurchase.id
                    
                })
                dispatch({
                    type: "NEW_ARRIVAGE",
                    payload: createdPurchase
                    
                })
                dispatch(fetchStocks())
                dispatch({ type: "CREATE_ARRIVAGE_FULFILLED", payload:"" })
                console.log("Purchase created")
            } else {
                dispatch({
                    type: "CREATE_ARRIVAGE_ERROR",
                    payload: createdPurchase.error.message
                    
                })
                
            }
            
        } catch (err) {
            console.log("[ERROR] SUBMIT ARRIVAGE ", err);
            dispatch({
                type: "CREATE_ARRIVAGE_ERROR",
                payload: err
                
            })
        }
    }
}
export function createDemand(newPurchase,isUpdate = false){ //isUpdate indique si cest une mise à jour ou pas
    return async function(dispatch){
        dispatch({
            type: "CREATE_DEMAND_START",
            payload: ""
            
        })
        try {
            const response = await fetch('/stocks/addData',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page:"purchases/demands",
                    data: newPurchase
                }),
                credentials: 'same-origin',
            }); 
            
            const createdPurchase = await response.json()
            console.log(createdPurchase)// createdPurchase returns new object created

            if(createdPurchase.id){ // no errors, return new Object

                if (isUpdate){ //Test si nouvelle demande ou Modification
                    console.log("[DEBUG],createDemandUPDATE_DEMAND ")
                    dispatch({
                        type: "NEW_DEMAND",
                        payload: createdPurchase
                        
                    })
                    dispatch({
                        type: "DELETE_DEMAND",
                        payload: newPurchase.id
                    })
                }else{
                    dispatch({
                        type: "NEW_DEMAND",
                        payload: createdPurchase
                        
                    })
                }
                dispatch(fetchStocks())
                dispatch({ type: "CREATE_DEMAND_FULFILLED", payload:"" })
                console.log("Purchase created")
            } else {
                dispatch({
                    type: "CREATE_DEMAND_ERROR",
                    payload: createdPurchase.error.message
                    
                })
                
            }
            
        } catch (err) {
            console.log("[ERROR] SUBMIT ARRIVAGE ", err);
            dispatch({
                type: "CREATE_DEMAND_ERROR",
                payload: err
                
            })
        }
    }
}
export function receivePurchase(purchase){
    console.log("FIRED ACTION RECEIVE PURCHASE", purchase)
    return async function(dispatch){
        dispatch({ type: "RECEIVE_PURCHASE_START", payload: "" })
        try {
            const infos = await fetch('/stocks/changeStatus',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify(purchase),
                credentials: 'same-origin',
            });
            let updatedPurchase = await infos.json();
            console.log("[INFO] change status receive purchase ",updatedPurchase);// return true or false
            
            if(updatedPurchase.id){ // no errors, return new Object
                if(updatedPurchase.nature === "reapprovisionnement"){
                    dispatch({ type: "UPDATE_PURCHASE_REAPPRO", payload: updatedPurchase })
                } else {
                    dispatch({ type: "UPDATE_PURCHASE", payload: updatedPurchase })
                }
                dispatch({ type: "RECEIVE_PURCHASE_FULFILLED", payload:"" })
                console.log("Purchase UPDATED ")

                dispatch(fetchStocks())
            } else {
                dispatch({ type: "RECEIVE_PURCHASE_ERROR", payload: updatedPurchase.error.message })
            }
            
        } catch (err) {
            console.log("[ERROR] SUBMIT PURCHASE ", err);
            dispatch({ type: "RECEIVE_PURCHASE_ERROR", payload: err })
        }
    }
}

export function deletePurchase(purchase){
    return async function(dispatch){
        dispatch({ type: "DELETE_PURCHASE_START", payload: "" })
        try {
            const infos = await fetch('/stocks/cancelPurchase',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    purchase
                }),
                credentials: 'same-origin',
            });
            let res = await infos.json();
            console.log("[INFO] delete purchase res ",res);// return true or false
            
            // Backend now returns an object with {success: true/false, message: "..."}
            if(res === 'ok' || (res && (res.success === true || res.message))){ // Accept both old and new response formats
                dispatch({
                    type: "DELETE_PURCHASE",
                    payload: purchase.id
                })
                dispatch({ type: "DELETE_PURCHASE_FULFILLED", payload:"" })
                dispatch(fetchStocks())
                console.log("Purchase deleted")
                return "OK"
            } else {
                const errorMessage = res?.error?.message || res?.message || "Erreur lors de la suppression";
                dispatch({
                    type: "DELETE_PURCHASE_ERROR",
                    payload: errorMessage
                })
                throw new Error(errorMessage);
            }
        } catch (err) {
            console.log("[ERROR] DELETE PURCHASE ", err);
            dispatch({
                type: "DELETE_PURCHASE_ERROR",
                payload: err
            })
            throw err
        }
    }
}

export function deleteArrivage(arrivage){
    return async function(dispatch){
        dispatch({ type: "DELETE_ARRIVAGE_START", payload: "" })
        try {
            const response = await fetch('/stocks/delete',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    type: "arrivage",
                    data: arrivage
                }),
                credentials: 'same-origin',
            }); 
            const res = await response.json()
            console.log("DELETE ARRIVAGE RESPONSE",{res})

            if(res === "ok"){ // no errors, return new Object
                dispatch({ type: "DELETE_ARRIVAGE", payload: arrivage.op_id })
                dispatch({ type: "DELETE_ARRIVAGE_FULFILLED", payload:"" })
                dispatch(fetchStocks())
            } else {
                dispatch({
                    type: "DELETE_ARRIVAGE_ERROR",
                    payload: res.error.message
                })
            }
        } catch (err) {
            dispatch({  type: "DELETE_ARRIVAGE_ERROR", payload: err })
        }
    }
}
export function deleteDemand(demand){
    return async function(dispatch){
        dispatch({ type: "DELETE_DEMAND_START", payload: "" })
        try {
            const response = await fetch('/stocks/delete',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    type: "demand",
                    data: demand
                }),
                credentials: 'same-origin',
            }); 
            const res = await response.json()
            console.log("DELETE DEMAND RESPONSE",{res})

            if(res === "ok"){ // no errors, return new Object
                dispatch({ type: "DELETE_DEMAND", payload: demand.op_id })
                dispatch({ type: "DELETE_DEMAND_FULFILLED", payload:"" })
                dispatch(fetchStocks())
                return "OK"
            } else {
                dispatch({
                    type: "DELETE_DEMAND_ERROR",
                    payload: res.error.message
                })
            }
            throw new Error(res.error.message)
        } catch (err) {
            dispatch({  type: "DELETE_DEMAND_ERROR", payload: err })
            throw err;
        }
    }
}

export function getPurchases(purchases){
    let newList = {
        PURCHASES : {},
        REAPPRO : {},
        ALL : purchases,
    }
    Object.keys(purchases).map((purchaseID) => {
        if(purchases[purchaseID].nature !== 'reapprovisionnement'){
            newList.PURCHASES[purchaseID] = purchases[purchaseID]
        } else {
            newList.REAPPRO[purchaseID] = purchases[purchaseID]
        }
    })
    console.log("FIRED ACTION GET PURCHASES", newList)

    newList.PURCHASES = newList.PURCHASES && sortByPendingThenDate(Object.values(newList.PURCHASES));
    newList.REAPPRO = newList.REAPPRO && sortByPendingThenDate(Object.values(newList.REAPPRO));
    newList.ALL = newList.ALL && sortByPendingThenDate(Object.values(newList.ALL));
    
    return {
        type: "GET_PURCHASES",
        payload: newList       
    }
    
}
export function getArrivages(arrivages){
    return {
        type: "GET_ARRIVAGES",
        payload: arrivages       
    }
    
}
export function getDemandes(demandes){
    return {
        type: "GET_DEMANDS",
        payload: demandes       
    }
    
}
export function getPurchase(purchase_Id){
    // console.log("FIRED ACTION GET PURCHASES", purchases)
    return {
        type: "GET_PURCHASE",
        payload: purchase_Id
        
    }
}

function sortByDate(list, field = 'date') {
    // console.log(list);
    let newList = {}
    list.sort((a, b) => {
        return new Date(b[field]) - new Date(a[field])
    });

    list.map( item => {
        newList[item.id] = item
    })

    console.log('====================================');
    console.log({ newList, list});
    console.log('====================================');
    return newList
  }

function sortByPendingThenDate(list, field = 'date') {
    let newList = {}
    list.sort((a, b) => {
        const aPending = a.received ? 1 : 0;
        const bPending = b.received ? 1 : 0;
        if (aPending !== bPending) return aPending - bPending;
        return new Date(b[field]) - new Date(a[field]);
    });

    list.map( item => {
        newList[item.id] = item
    })

    return newList
  }

  export function linkPurchasesTo5000(data){
    return async function (dispatch){
        dispatch({ type: "LINK_PAYMENTS_START", payload: "" })
        try {
            // Un seul appel : le serveur enchaîne storehouse puis la comptabilité 5000 et
            // annule le pointage 8000 si le 5000 ne répond pas. L'enchaînement était fait ici,
            // depuis le navigateur ; rien ne garantissait que le second appel parte, et
            // l'écriture 5000 restait alors créditée alors qu'elle était déjà consommée.
            const req = await fetch('/stocks/compta/purchases/link', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
                credentials: 'same-origin',
            });
            const res = await req.json();

            if (res.error) {
                dispatch({ type: "LINK_PURCHASES_ERROR", payload: res.error })
                // Le résultat est rendu à l'appelant : lire l'erreur dans le store juste après l'await
                // renverrait la valeur capturée au rendu précédent, et l'écran annoncerait un succès.
                return { ok: false, error: res.error }
            }
            dispatch({
                type: "UPDATE_PURCHASES_LINK",
                payload: {list: Object.keys(data.id_list), spending_id: data.spending_id}
            })
            dispatch({ type: "LINK_PURCHASES_FULFILLED", payload: "" })

            return { ok: true }
        } catch (error) {
            console.log("[ERROR] link to compta : ", error);
            dispatch({ type: "LINK_PURCHASES_ERROR", payload: error.message })
        }
    }
}
export function unLinkPurchasesTo5000(data){
    return async function (dispatch){
        dispatch({ type: "LINK_PURCHASES_START", payload: "" })
        try {
            // Un seul appel : le serveur enchaîne le 8000 puis la comptabilité 5000 et rétablit
            // l'état antérieur si le second n'aboutit pas. L'enchaînement était fait ici, depuis
            // le navigateur, sans garantie que le second appel parte.
            const req = await fetch('/stocks/compta/purchases/unlink', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
                credentials: 'same-origin',
            });
            const res = await req.json();

            if (res.error) {
                dispatch({ type: "LINK_PURCHASES_ERROR", payload: res.error })
                // Le résultat est rendu à l'appelant : lire l'erreur dans le store juste après l'await
                // renverrait la valeur capturée au rendu précédent, et l'écran annoncerait un succès.
                return { ok: false, error: res.error }
            }
            dispatch({
                type: "UPDATE_PURCHASES_UNLINK",
                payload: {list: Object.values(data.id_list)}
            })
            dispatch({ type: "LINK_PURCHASES_FULFILLED", payload: "" })

            // `warning` : dépointage fait côté 8000 seul, l'écriture 5000 n'existant plus.
            return { ok: true, warning: res.warning }
        } catch (error) {
            console.log("[ERROR] rapprochement 5000 : ", error);
            dispatch({ type: "LINK_PURCHASES_ERROR", payload: error.message })
        }
    }
}
